import React from 'react';
import {MasterLayout} from 'layout';
import {XuLyGiaiQuyetDon} from "modules/giai-quyet-don";

export default class XuLyGiaiQuyetDonPage extends React.Component {
 
  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
          <XuLyGiaiQuyetDon status='DANG_GIAI_QUYET' params={this.props.params}/>
      </MasterLayout>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/giai-quyet-don/XuLyGiaiQuyetDonPage.jsx